import GooperLightFont from '../assets/fonts/Gooper-Light.woff2';
import AbcOracleLightFont from '../assets/fonts/ABC-Oracle-Light.woff2';
import AbcOracleRegularFont from '../assets/fonts/ABC-Oracle-Regular.woff2';

const gooperLight = {
  fontFamily: 'Gooper',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 300,
  src: `
    local('Gooper-Light'),
    local('Gooper'),
    url(${GooperLightFont}) format('woff2')
  `,
};

const abcOracleLight = {
  fontFamily: 'ABC Oracle',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 300,
  src: `
    local('ABC-Oracle-Light'),
    local('ABC-Oracle'),
    url(${AbcOracleLightFont}) format('woff2')
  `,
};

const abcOracleRegular = {
  fontFamily: 'ABC Oracle',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    local('ABC-Oracle-Regular'),
    local('ABC-Oracle'),
    url(${AbcOracleRegularFont}) format('woff2')
  `,
};

export const fonts = [gooperLight, abcOracleLight, abcOracleRegular];
